import { AnyObject } from '@data-driven-forms/react-form-renderer/dist/cjs/common';

import { FIELD_NAMES, GENDER_LABELS, hasInsuranceCondition, languages, StepNames } from '../..';
import {
  DBFormSchema,
  fieldFormattedPlainTextSection,
  fieldPlainTextSection,
  fieldSelectSection,
  fieldTextSection,
  headerSection,
  spacerSection
} from '../field-helpers';

const { patientFields } = FIELD_NAMES;

export const copayPatientTabFields = (schema: DBFormSchema, nextStep?: StepNames | AnyObject) => {
  const copayPatientTab = schema?.patient_tab;

  if (!copayPatientTab || copayPatientTab?.hideTab) return null;

  return {
    title: copayPatientTab?.label ?? 'Patient',
    name: StepNames.COPAYPATIENT,
    nextStep: copayPatientTab?.nextStep ?? nextStep,
    fields: [
      headerSection(schema?.personal_information_header?.label, schema?.personal_information_header),
      spacerSection(2, { sizes: { sm: 12 }, className: 'mb-3 spacer-hr' }),
      fieldPlainTextSection(patientFields.firstName, schema?.[patientFields.firstName], {
        sizes: { md: 3 },
        style: { fontWeight: '700' }
      }),
      fieldPlainTextSection(patientFields.middleName, schema?.[patientFields.middleName], {
        sizes: { md: 3 }
      }),
      fieldPlainTextSection(patientFields.lastName, schema?.[patientFields.lastName], {
        sizes: { md: 3 }
      }),
      fieldPlainTextSection(patientFields.dob, schema?.[patientFields.dob], {
        sizes: { md: 3 }
      }),
      spacerSection('patient_1', { sizes: { sm: 12 } }),
      fieldFormattedPlainTextSection(patientFields.gender, schema?.[patientFields.gender], {
        sizes: { md: 4 },
        formatter: (val: string) => GENDER_LABELS[val] || val
      }),
      fieldPlainTextSection(patientFields.genderOther, schema?.[patientFields.genderOther], {
        sizes: { md: 4 },
        condition: {
          when: patientFields.gender,
          is: 'O'
        }
      }),

      fieldTextSection(patientFields.mobileNumber, schema?.[patientFields.mobileNumber], {
        sizes: { md: 2 },
        type: 'tel',
        validate: [
          {
            type: 'phone-conditional',
            compareToField: patientFields.homeNumber
          }
        ]
      }),
      fieldSelectSection(patientFields.preferredPhone, schema?.[patientFields.preferredPhone], {
        sizes: { md: 4 }
      })
    ].filter(Boolean)
  };
};
